import * as React from 'react';
import {connect} from 'react-redux';
import {Dispatch} from 'redux';
import {IconButton} from '@openfin/desktop-ui';

import * as BookmarkInactive from '../../../assets/BookmarkInactive.svg';
import * as BookmarkActive from '../../../assets/BookmarkActive.svg';
import {App} from '../../../types/commons';
import {RootState} from '../../../store/State';
import {PinApplication, UnpinApplication, isPinnedApp} from '../../../store/partials/Settings';

type AppId = App['id'];

interface Props {
    app: App;
    className?: string;
    getIsPinnedApp: (appId: AppId) => boolean;
    pinApplication: (appId: string) => void;
    unpinApplication: (appId: string) => void;
}

/**
 * Renders a bookmark icon with baked in application pinning functionality.
 */
const ApplicationPinComponent: React.FC<Props> = (props) => {
    const {app, getIsPinnedApp, pinApplication, unpinApplication, className} = props;
    const isAppPinned = getIsPinnedApp(app.id);

    const handlePinApp = (event: React.MouseEvent) => {
        event.stopPropagation();
        event.preventDefault();

        pinApplication(app.id);
    };

    const handleUnpinApp = (event: React.MouseEvent) => {
        event.stopPropagation();
        event.preventDefault();

        unpinApplication(app.id);
    };

    return (
        <IconButton
            image={isAppPinned ? BookmarkActive : BookmarkInactive}
            onClick={isAppPinned ? handleUnpinApp : handlePinApp}
            className={className}
        />
    );
};

const mapState = (state: RootState) => ({
    getIsPinnedApp: (appId: AppId) => isPinnedApp(state, appId)
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    pinApplication: (appId: string) => dispatch(new PinApplication(appId)),
    unpinApplication: (appId: string) => dispatch(new UnpinApplication(appId))
});

export const ApplicationPin = connect(mapState, mapDispatchToProps)(ApplicationPinComponent);
